<template>
  <div>
    <main id="page_sub">
      <section id="page_contents">
        <h5>공지사항</h5>
        <div class="sl_box">조회수
          <span>{{dataItems.hitCnt}}</span>
          건
        </div>
        <!--공지기간 --->
        <div class="sr_box">
          <p>
            <span>공지 기간</span>
            {{dataItems.brdFrom}} ~ {{dataItems.brdTo}}
          </p>
        </div>
        <!---//공지기간 --->
        <div id="notice">
          <table cellspacing="0">
            <caption>
              공지사항게시판
            </caption>
            <tr>
              <th class="tview">
                <!--<span class="mbt">경영공지</span>-->
                <p>{{dataItems.title}}</p>
                <span>{{dataItems.rgstDt}} &nbsp;|&nbsp; {{dataItems.lastMdfyId}}</span>
              </th>
            </tr>
            <tr>
              <td class="tcon" v-html="dataItems.contents"></td>
            </tr>
          </table>
        </div>
       <div class="Attach" v-show="fileExist" >첨부파일

         <a @click.prevent="getFileDownLoad(file.fileId,file.seqNo,file.orgFileNm)" style="cursor: pointer" v-for="file in dataItems.boardFiles">{{file.orgFileNm}}({{0.001*parseInt(file.fileSize)}} KB)</a>

       </div>
        <div class="viewLink">
          <dl class="btnPrev">
            <dt>이전글</dt>
            <dd>
              <template v-if="dataItems.prevTitle === null">
                <span style="cursor: pointer">이전글이 없습니다.</span>
              </template>
              <template v-else>
                <router-link :to="{ name: 'NoticeDetail', query: { brdNo: dataItems.prevBrdNo } }">
                  {{dataItems.prevTitle}}
                </router-link>
              </template>
            </dd>
          </dl>
          <dl class="btnNext">
            <dt>다음글</dt>
            <dd>
              <template v-if="dataItems.nextTitle === null">
                <span style="cursor: pointer">다음글이 없습니다.</span>
              </template>
              <template v-else>
                <router-link :to="{ name: 'NoticeDetail', query: { brdNo: dataItems.nextBrdNo } }">
                  {{dataItems.nextTitle}}
                </router-link>
              </template>
            </dd>
          </dl>
        </div>
        <!--- 버튼영역/켄도사용 --->
        <div class="btn_area mt20">
          <kendo-button class="k-primary k-button k-big" @click="modifyNotice" v-if="isAdminUser === true">
            수정
          </kendo-button>
          <kendo-button class="k-button k-big" @click="deleteNotice" v-if="isAdminUser === true">
            삭제
          </kendo-button>
          <router-link :to="{ name: 'Notice' }" tag="button" class="k-button k-big" aria-disabled="false" tabindex="0">
            목록
          </router-link>
        </div>
        <!--- //버튼영역 --->
      </section>
    </main>
  </div>

</template>

<script>
  import ApiConfig from '@/api/api.config'
  import axios from 'axios'
  export default {
    name: 'NoticeDetail',

    mounted () {
      let params = {
        loginUserToken: sessionStorage.getItem('lutk'),
        brdNo         : this.brdNo,
      }
       this.$store.dispatch('FETCH_NOTICE_DETAIL', params).then(data => {
         this.dataItems = data.resultData
         if(data.resultData.boardFiles.length > 0){
           this.fileExist =true
         }
       })
    },
    watch  : {
      '$route' (to) {
        this.brdNo = to.query.brdNo

        let params = {
          loginUserToken: sessionStorage.getItem('lutk'),
          brdNo         : this.brdNo,
        }
       this.$store.dispatch('FETCH_NOTICE_DETAIL', params).then(data => {
          this.dataItems = data.resultData
          if(data.resultData.boardFiles.length > 0){
            this.fileExist =true
          }
        })
      },
    },
    methods: {
      getFileDownLoad(fileId,seqNo,fileNm){
        const url = `${ApiConfig.platformDomain}/files/${fileId}/${seqNo}`
        this.downloadWithAxios(url,fileNm)
      },
      forceFileDownload(response,fileNm){
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileNm) //or any other extension
        document.body.appendChild(link)
        link.click()
      },
      downloadWithAxios(url,fileNm){
        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer'
        })
          .then(response => {

            this.forceFileDownload(response,fileNm)

          })
          .catch(() => console.log('error occured'))
    },
      modifyNotice () {
        let brdNo = this.brdNo
        const vue = this
        kendo.confirm('공지사항을 수정 하시겠습니까?').done(function () {
          vue.$router.push({ name: 'NoticeForm', query: { brdNo: brdNo } })
        })
      },
      deleteNotice () {
        const vue = this
        let params = {
          loginUserToken: sessionStorage.getItem('lutk'),
          brdGbn        : this.dataItems.brdGbn,
          brdNo         : this.brdNo,
        }
        kendo.confirm('공지사항을 삭제 하시겠습니까?').done(function () {

          vue.$store.dispatch('DELETE_NOTICE_DETAIL', params).then(data => {
            vue.$router.push({ name: 'Notice' })
          })
        })

      },
    },
    data () {
      let loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
      let isAdminUser = false

      if (loginUserData.authCd === '99999') {
        isAdminUser = true
      }

      return {
        isAdminUser: isAdminUser,
        brdNo      : this.$route.query.brdNo,
        dataItems  : [],
        fileExist  : false
      }
    },
  }
</script>

<style scoped>

</style>
